import { render, staticRenderFns } from "./TestDriveBtn.vue?vue&type=template&id=3ed3b4d6"
import script from "./TestDriveBtn.vue?vue&type=script&lang=js"
export * from "./TestDriveBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports